export const locales = {
	messagePatient: 'Pour afficher l’ensemble des services de cette rubrique, veuillez identifier votre patient.',
	messageCPS: 'Des services de simplification de vos démarches pour vos patients sont accessibles et sécurisés par l’utilisation de votre carte CPS.',
	messageCPS2: 'Pour vous identifier par carte CPS :',
	logOutBtn: 'Se déconnecter'
};
